<template>
    <v-form ref="form_quote">
        <v-row>
            <v-col cols="12" sm="6">
                <v-text-field
                    :rules=ruleRequire
                    outlined
                    dense
                    rounded
                >
                    <template v-slot:label>
                        <span class='gray--text font-title'> <i>Nombre *</i></span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                    :rules=ruleRequire
                    outlined
                    dense
                    rounded
                >
                    <template v-slot:label>
                        <span class='gray--text  font-title'> <i>Apellido *</i></span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                    :rules=ruleRequire
                    label="Email *"
                    outlined
                    dense
                    rounded
                >
                    <template v-slot:label>
                        <span class='gray--text  font-title'> <i>Email *</i></span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                    :rules=ruleRequire
                    outlined
                    dense
                    rounded
                    type="number"
                >
                    <template v-slot:label>
                        <span class='gray--text  font-title'> <i>Teléfono *</i></span>
                    </template>
                </v-text-field>
            </v-col>
                <v-col cols="12" >
                <v-text-field
                    :rules=ruleRequire
                    outlined
                    rounded
                    dense
                >
                    <template v-slot:label>
                        <span class='gray--text  font-title'> <i>Dirección *</i></span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="12" md="6" >
                 <v-text-field
                    :rules=ruleRequire
                    outlined
                    dense
                    rounded
                    type="number"
                >
                    <template v-slot:label>
                        <span class='gray--text  font-title'> <i>País *</i></span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                    :rules=ruleRequire
                    outlined
                    rounded
                    dense
                >
                    <template v-slot:label>
                        <span class='gray--text  font-title'> <i>Ciudad *</i></span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col
                cols="12"
            >
                <v-textarea outlined>
                    <template v-slot:label>
                        <span class='gray--text  font-title'><i>Mensaje</i></span>
                    </template>
                </v-textarea>
            </v-col>
        </v-row>
        <v-col>
            <v-btn 
                rounded 
                class='blue white--text font-title px-8'
                @click="sendQuote"
            >
                <b><i>Enviar</i></b>
            </v-btn>
            <v-btn 
                rounded 
                class='blue float-right white--text font-title px-8'
                @click="setCheckout(false)"
            >
                <b><i>Productos</i></b>
            </v-btn>
        </v-col>
        
    </v-form>
</template>

<script>
import {mapMutations} from 'vuex'

export default {
    name:'CheckoutProductsComponent',
    data: ()=>({
        ruleRequire: [v => !!v || "El campo es obligatorio"],
    }),

    methods:{

        ...mapMutations(['setCheckout']),
        
        sendQuote(){
            if(!this.$refs.form_quote.validate())
                return false

        }

    }
}
</script>

<style scope>
    form fieldset {
        border:2px solid #ffaa45!important
    }
</style>